module.exports = __webpack_public_path__ + "static/images/biditem4_57083e6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tab/content/biditem4.png
// module id = 96
// module chunks = 1